// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"bf8febef","453":"9e360ccc"}[chunkId] + ".chunk.js";
};